<form class="lv-artefact-container lv-component"
      [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <div class="lv-artefact" [ngClass]="uiArtefakt.BreiteInPixel">
    <lv-label-tooltip [label]="uiArtefakt.Text" [labelSymbol]="nestedSymbol"
                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
                      [isPflichtfeld]="uiArtefakt.PflichtfeldJN"
                      [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"
                      (infotextCollapsableChange)="infotextCollapsableChange($event)"></lv-label-tooltip>
    <lv-info-text-tooltip-collapsable [showInfotext]="showInfotextCollapsable"
                                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"></lv-info-text-tooltip-collapsable>
    <div>
      <mat-form-field class="lv-material-form-input" #formField [hideRequiredMarker]="true"
                      [floatLabel]="'never'">
        <lv-telefonnummer-inputs lvMobilnummerValidator [name]="uiArtefakt.Identifikator" #phoneInput="ngModel" [(ngModel)]="model"
                                 [uiArtefakt]="uiArtefakt" (focusEvent)="isTouched = $event; onBlur()"
                                 [errorState]="!!getError()" [disabled]=isDisabled>
        </lv-telefonnummer-inputs>
        <mat-error *ngIf="getError() as error" class="lv-control-error"
                   [ngClass]="{'lv-show-untruncated-error': showUntruncatedError}"
                   (click)="onErrorClick()">
          {{error}}
        </mat-error>
      </mat-form-field>
    </div>
    <lv-infotext-permanent
        [InfoTextPermanent]="uiArtefakt.InfoTextPermanent"></lv-infotext-permanent>
  </div>
</form>

